import React, { Fragment } from 'react';
import { Button, Card, CardBody, Col, Container, Row, Input, CardHeader, Nav, NavLink } from 'reactstrap';
import { usePrices } from '../../../hooks/prices/usePrices';
import { ModalPrices } from '../../../components/prices/ModalPrices';
import { useHistory } from 'react-router-dom';
import { TitleDataTable } from '../../../components/tableDataTable/TitleDataTable';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import '../../configuraciones/prices/StylePices.css'
export const IndexPrices = () => {

    const history = useHistory();

    const {
        rate, prices, method, handleInputChange, validacionesPrice,
        price, from, to, id_examProfile,
        toggle, modal, modalTitle, loading,
        handleCreate, saveCreate,
        handleUpdate, saveUpdate,
        handleDelete, saveDelete,
        examProfileState,
        handlePickerValues, validInputDate, validToInputDate,
        //totalPageCount, currentPage, nextPage, previousPage, goToPage,handleSearch
        goNextPage, goPreviousPage, goToPage, actualPage, totalPages, prevPage, nextPage,

        handleSearch, metaData, examsData,
        isCurve, curves, addCurve, editCurve,
        handleClearPrice, searchPrice,
        closeDialog, handleExportPrice, loadingExport

    } = usePrices();

   
    const headerStyle = {
        backgroundColor: "#1d5b83",
        color: "#fff",
        fontWeight: "bold",
        fontSize: "11px",
        borderRight: "1px solid #fff",
        borderBottom: "2px solid #fff",
    };

    const cellStyle = {
        fontSize: "11px",
        padding: "5px",
        textAlign: "center",
        fontFamily: "Montserrat, sans-serif",

    };

    const centerStyle = {
        ...cellStyle,
        textAlign: "center",
    };

    // const actions = (rowData) => {

    //     return (
    //         <div className="d-flex justify-content-center align-items-center" style={{ gap: "3px", marginRight: "3px" }}>
    //             <Button
    //                 size="sm"
    //                 onClick={() => handleUpdate(rowData.id_price)}
    //                 title="Editar sucursal"
    //                 className="btnTableAction"
    //             >
    //                 <i className="fa fa-edit iconTableAction"></i>
    //             </Button>

               
    //         </div>
    //     );
    // };
    

    return (
        <Fragment>
            {/* <Breadcrumb parent="Configuraciones" title={"Tarifario gatos " + rate.name} /> */}
            <Container fluid={true}>
                
                <div className='container-global-zoom'>
                    <div className="customizer-links" style={{ width: "65px" }} >
                        <Nav className="flex-column nac-pills">
                            <NavLink onClick={() => history.goBack()} style={{cursor:'pointer'}} >
                                <div className="settings"  >
                                    <i className="fa fa-reply f-18"></i>
                                </div>
                                <span>{"Regresar"}</span>
                            </NavLink>
                        </Nav>
                    </div>

                    <Row>
                        <Col sm="12">
                            <Card>
                                <CardBody className="p-1">
        
                                    <Col sm="12" className='p-l-0 p-r-0 pb-2 pt -3' >
                                        <TitleDataTable
                                            titleTable="Listado de precios"
                                            buttonActions={handleExportPrice}
                                            titleButton="Excel de precios de tarifarios"
                                            isDisbled={loadingExport}
                                            loadingIsDisabled={loadingExport}
                                            titleCreate="Crear precio de estudio"
                                            buttonActionsCreate={handleCreate}
                                            actionInput={handleSearch}
                                            valueFilter={searchPrice}
                                            filterLocalStorage={true}
                                            cleanFilterLocalStorage={handleClearPrice}
        
                                        />
                                    </Col>
                                
                                    <div className="table-responsive">
                                        
                                        <DataTable
                                            value={metaData}
                                            paginator
                                            lazy
                                            first={(actualPage - 1) * 10}
                                            rows={10}
                                            totalRecords={totalPages * 10}
                                            onPage={(e) => {goToPage(e.page + 1);}}
                                            className="data-table p-datatable-striped p-datatable-sm"
                                            emptyMessage={
                                                <div className="text-center">
                                                    <img
                                                        src={require("../../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")}
                                                        style={{ width: "32%" }}
                                                        alt="Sin resultados"
                                                    />
                                                    <br />
                                                    <p className="badge badge-light-primary mt-2" style={{ fontSize: "15px" }}>
                                                        No se encontraron resultados.
                                                    </p>
                                                </div>
                                            }
                                        >
        
                                            <Column header="#" body={(rowData, options) => { const globalIndex = options.rowIndex; return globalIndex + 1; }} headerStyle={headerStyle} style={centerStyle} />
                                            <Column 
                                                field="name_exam" 
                                                header="Nombre" 
                                                headerStyle={headerStyle} 
                                                style={cellStyle}
                                                body={(rowData) => (
                                                    <span style={{ fontWeight: "bold" }}>
                                                        {rowData.name_exam}
                                                    </span>
                                                )}
                                            />
        
                                            <Column 
                                                field="price" 
                                                header="Precio"
                                                body={(rowData) => { 

                                                    return (
                                                        <div
                                                            style={{
                                                                display: "flex",
                                                                justifyContent: "center",
                                                                alignItems: "center",
                                                            }}
                                                        >
                                                            <span
                                                                style={{
                                                                    minWidth: "90px",
                                                                    textAlign: "center",

                                                                    padding: "6px 14px",

                                                                    borderRadius: "999px",

                                                                    background: "linear-gradient(135deg, #34d399, #10b981)",

                                                                    color: "#fff",

                                                                    fontSize: "12px",
                                                                    fontWeight: "700",

                                                                    letterSpacing: ".3px",

                                                                    boxShadow: "0 6px 16px rgba(16,185,129,0.28)",

                                                                    border: "1px solid rgba(255,255,255,0.18)",

                                                                    backdropFilter: "blur(8px)",

                                                                    display: "inline-flex",
                                                                    alignItems: "center",
                                                                    justifyContent: "center",
                                                                    gap: "4px",
                                                                }}
                                                            >
                                                               

                                                                {(rowData?.price ?? 0)}
                                                            </span>
                                                        </div>
                                                    );
                                                }} 
                                                headerStyle={headerStyle} 
                                                style={cellStyle} 
                                            />
        
                                            <Column 
                                                field="from" 
                                                header="Valido desde" 
                                                headerStyle={headerStyle} 
                                                style={cellStyle}
                                                body={(rowData) => (
                                                    <span>
                                                        {rowData.from}
                                                    </span>
                                                )}
                                            />
        
                                            <Column 
                                                field="to"
                                                header="Valido hasta" 
                                                body={(rowData) => (
                                                    <span>
                                                        {rowData.to}
                                                    </span>
                                                )}
                                                headerStyle={headerStyle} 
                                                style={cellStyle} 
                                            />
        
                                            
                                            {/* <Column header="Acciones" body={actions} exportable={false} headerStyle={headerStyle} style={centerStyle} /> */}
                                        </DataTable>
                                    </div>
        
                                    {/* {showDeleteAlert && (
                                        <AlertDataTable
                                            titleAlert="Eliminar tipo de muestra"
                                            visibleAlert={modalAlert}
                                            onHideAlert={closeDeleteAlert}
                                            sizeAlert="medium-dialog delete-method"
                                            messageAlert="Esta acción no se puede deshacer. ¿Estás seguro de eliminar el tipo de muestra?"
                                            alert1={true}
                                            titleAlert1={name}
                                            buttonAcept
                                            titleNotLoading="Eliminar"
                                            titleDanger="Cancelar"
                                            actionAcept={saveDelete}
                                        />
            
                                    )} */}
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                
                </div>
               
            </Container>
            <ModalPrices
                {
                ...{
                    modal, closeDialog, modalTitle, method, loading,
                    handleInputChange, handlePickerValues, validacionesPrice,
                    price, from, to, id_examProfile,
                    saveCreate, saveUpdate, saveDelete,
                    examProfileState,
                    validInputDate, validToInputDate,
                    isCurve, curves, addCurve, editCurve,
                    
                }
                }
            />
        </Fragment>
    )
}
